// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"citySelect_wrapper__TQzAe","button":"citySelect_button__14fjs","list-button":"citySelect_list-button__2FoBT","list":"citySelect_list__2nGfw"};